(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityIcd10', FacilityIcd10);

    FacilityIcd10.$inject = ['$resource'];

    function FacilityIcd10 ($resource) {
        var resourceUrl =  'api/facility-icd-10-s/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/facility-icd-10-s/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
